import { render, staticRenderFns } from "./VMAllocations.vue?vue&type=template&id=97fdbbdc&"
import script from "./VMAllocations.vue?vue&type=script&lang=js&"
export * from "./VMAllocations.vue?vue&type=script&lang=js&"
import style0 from "./VMAllocations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports